import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";

function MondayHappyHoursPromo(props) {
    const {
        app: { brandId },
        theme,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const domain = brandId == 31 || brandId == 32 || brandId == 61 ? "Yolo247" : brandId == 39 || brandId == 40 ? "FOMO7" : "IW247";

    return (
        <>
            <InformationWrapper>
                {/* Top Caption */}

                <TopCaption>
                    <h4>Monday Happy Hour</h4>
                    <h6>Deposit & Win Instantly</h6>
                    <p>
                        Deposit during Happy Hour (6 PM - 7 PM) every Monday and receive an instant <br /> bonus to kickstart your play.
                    </p>
                </TopCaption>


                <RestSecWrap>
                {/* Left */}
                <LeftSecWrap>
                    <SectionTitle>
                        <p>How to <br /> <span>Participate</span></p>
                         <img
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourQMIconDesk}`}
                            alt="question mark"
                            className=""
                         />
                    </SectionTitle>

                    <StepsRow>
                        <StepCard>
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourSteps01Desk}`}
                                alt="Model"
                                className="modelImg"
                            />
                        </StepCard>

                        <StepCard>
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourSteps02Desk}`}
                                alt="Model"
                                className="modelImg"
                            />
                        </StepCard>

                        <StepCard>
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourSteps03Desk}`}
                                alt="Model"
                                className="modelImg"
                            />
                        </StepCard>
                    </StepsRow>
                </LeftSecWrap>


                {/* Middle */}
                <ModelWrapper>
                    <img
                        src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourModelDesk}`}
                        alt="Model"
                        className="modelImg"
                    />
                </ModelWrapper>

                <RightSecWrap>
                    {/* Right */}
                    <TermsTitle>
                        <p>Terms & <br /> <span>Conditions</span></p>
                         <img
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourAlertIconDesk}`}
                            alt="alert icon"
                            className=""
                         />
                    </TermsTitle>

                    <TermsCard>
                        <ul>
                            <li>Instant bonus up to <strong>{brandId === 61 ? "$21" : "₹206"}</strong></li>
                            <li>
                                Valid <strong>once per user every Monday</strong>
                            </li>
                            <li>
                                Bonus wagering requirements apply
                            </li>
                            <li>Estimated total prize pool: <strong>{brandId === 61 ? "$520,000" : "₹52,00,000"}</strong></li>
                            <li>Deposits made <strong>outside the 6-7 PM <br /> window are not eligible</strong></li>
                            <li><strong>{domain} reserves the right </strong> to modify or <br /> cancel the promotion without prior notice</li>
                            <li><strong>General {domain} terms & conditions apply</strong></li>
                        </ul>
                    </TermsCard>
                </RightSecWrap>
                </RestSecWrap>
            </InformationWrapper>

        </>
    );
}

export default withTheme(withAppContext(MondayHappyHoursPromo));

/* ===================== STYLES ===================== */

const InformationWrapper = styled.div`
  width: 98%;
  height: auto;
  padding: 1.5rem 0 0rem 0;
  margin: 0em 1.2em 0 1.2em;
  border: 1px solid #fff;
  display: flex;
  flex-direction: column;
  background: url(${config.imageV3Host}/static/cashsite/${theme("image.mondayHappyHourInnerBgDesk")});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;

  .boldText {
    color: ${theme("palette.informationWrapperPromoBoldText")};
    font-weight: 700;
  }

  .boldTextLite {
    color: #ffffff;
    font-weight: 700;
  }

  .brandColor {
    color: ${theme("palette.suprChknRushBrandTextColor")};
    font-weight: 700;
  }
`;

const TopCaption = styled.div`
  width: 90%;
  margin-bottom: 2rem;
  max-width: 1520px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 2em auto 3em auto;
  position: relative;

  & h4 {
    color: ${theme("palette.mondayHappyHourTextColor")};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    margin: 3px 0px;
  }

  & h6 {
    color: rgba(255, 255, 255, 0.50);
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    margin: 3px 0px;
  }

  & p {
        color: #FFF;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 171.429% */
        margin: 3px 0px;
  }

  &::before{
    content: "";
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.mondayHappyHourDollarIconDesk")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    left: -60px;
    bottom: -30px;
    width: 120px;
    height: 110px;
  }


`;

const ModelWrapper = styled.div`
  width: 30%;
  height: auto;

  .modelImg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0px 12px 30px rgba(0, 0, 0, 0.7));
  }
`;

const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.3rem;
  margin-bottom: 1rem;
  align-items: center;
  margin: auto;
  width: 75%;

  & p {
    color: ${theme("palette.mondayHappyHourTextColor")};
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    margin: 3px 0px;
  }

  span {
    color: rgba(255, 255, 255, 0.50);
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    margin: 3px 0px;
  }

  & img {
    width: 110px;
    height: 130px;
    object-fit: contain;
  }
`;

const StepsRow = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
  flex-direction: column;
`;

const StepCard = styled.div`
    width: 100%;
    height: auto;
    border-radius: 10px;
    display: flex;
    justify-content: center;

    img {
        width: 75%;
        height: auto;
        border-radius: 8px;
        object-fit: contain;
    }
  
`;

const TermsTitle = styled.div`
  display: flex;
  gap: 0.4rem;
  margin-top: 2.2rem;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin: 0 auto;

  & p {
    color: ${theme("palette.mondayHappyHourTextColor")};
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    margin: 3px 0px;
  }

  span {
    color: rgba(255, 255, 255, 0.50);
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    margin: 3px 0px;
  }

  & img {
    width: 110px;
    height: 130px;
    object-fit: contain;
  }
`;

const TermsCard = styled.div`
  width: 100%;
  height: 75%;
  background: rgba(0, 0, 0, 0.45);
  padding: 22px 28px;
  background: url(${config.imageV3Host}/static/cashsite/${theme("image.mondayHappyHourTermsBgDesk")});
  background-position: top;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;

  &::before{
    content: "";
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.mondayHappyHourGiftIconDesk")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    left: -25px;
    bottom: -30px;
    width: 120px;
    height: 110px;
  }

  ul {
    margin: 0;
    padding-left: 4.15rem;
    display: flex;
    flex-direction: column;
    gap: 0.55rem;

    li {
      font-size: 18px;
      color: #FFF;
      line-height: 1.35;
      font-weight: 400;

      & strong {
        color: ${theme("palette.mondayHappyHourTextColor")};
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
      }
    }
  }
`;

const LeftSecWrap = styled.div`
    width: 30%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding-bottom: 5em;
    position: relative;

    &::after{
        content: "";
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.mondayHappyHourLikeIconDesk")});
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        position: absolute;
        right: -25px;
        top: 230px;
        width: 30px;
        height: 45px;
    }
`

const RightSecWrap = styled.div`
    width: 40%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding-bottom: 5em;
`

const RestSecWrap = styled.div`
    display: flex;
    width: 90%;
    justify-content: center;
    gap: 10px;
    max-width: 1520px;
    margin: 0 auto;
`